var _defs, _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalkonSmsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 560.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1450ff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 217.04,
    x2: 146,
    y2: 217.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffad00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 530.32,
    y1: 317.39,
    x2: 800,
    y2: 317.39,
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.2,
    y: 38.8,
    width: 146,
    height: 54.75,
    rx: 27.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.3,
    y: 342.5,
    width: 146,
    height: 54.75,
    rx: 27.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 189.7,
    width: 146,
    height: 54.75,
    rx: 27.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M710,232.3c-69.9-18.6-112.8,16.2-179.7,29.9L648,379.8c8.4,8.5,13.7,18.5,15.7,28.1.7-2.5,1.5-4.8,2.2-6.8C713.6,266.5,800,309.4,800,309.4S782.5,251.5,710,232.3Z",
    transform: "translate(0 -135.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.1,148.4,655.9,373.5a46.6,46.6,0,0,1,1.7,66L416.9,692.8a10,10,0,0,1-17.2-6.6l-2.7-108L193.9,385.3a46.7,46.7,0,0,1-1.6-66L353.1,150.1A46.6,46.6,0,0,1,419.1,148.4Zm52.1,317.8a32.1,32.1,0,1,0-1.2-45.4A32.1,32.1,0,0,0,471.2,466.2Zm-69.8-66.4a32.1,32.1,0,1,0-1.2-45.4A32.2,32.2,0,0,0,401.4,399.8Zm-69.8-66.3a32.1,32.1,0,1,0-1.2-45.4A32,32,0,0,0,331.6,333.5Z",
    transform: "translate(0 -135.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonSmsLogo);
export default __webpack_public_path__ + "static/media/falkon-sms-logo.ff9325059d0e64fe0ab5d45405ca18e9.svg";
export { ForwardRef as ReactComponent };